


















































































































































































































































































































































































































































































































































































import Vue, { PropType } from "vue";
import axios from "axios";
import store from "@/store";
import moment, { Moment } from "moment";

import MessageModal from "@/parts/util/MessageModal.vue";
import Editor from "@/parts/review/Editor.vue";
import ReturnTop from "@/parts/util/ReturnTop.vue";
import CommentCodeBlock from "@/parts/corporate_review/CommentCodeBlock.vue";
import VariableInput from "@/components/util/VariableInput.vue";

import { ErrorResponse } from "@/api/dto/Error";
import { CodeBlock, ReviewComment } from "@/api/dto/CodeEditor";
import {
  ReviewResponse,
  UpdateCorporateReviewStatusRequest,
  ReviewCommentRequest,
  RegisterCorporateReviewCommentZipFile,
} from "@/api/dto/ReviewCorporate";
import { DealResponse } from "@/api/dto/Deal";
import { UserProfile } from "@/api/dto/UserProfile";
import { Code, ZipFile, GithubUrl } from "@/api/dto/CorporateDealType";
import { Assessment, Approval, Rejection, AssessmentStatus } from "@/api/dto/AssessmentStatus";
import { Draft, UnderReview, AgreementPending, InReview, Completed } from "@/views/corporate/forms/DealStatus";
import { getReview, updateReviewStatus, registerZipFile } from "@/api/ReviewCorporate";
import { defaultIconUrl, genericExtension } from "@/properties";
import { getUserNickName } from "@/utils/labelUtils";

import hljs from "highlight.js";
import hljsCobol from "highlightjs-cobol";

hljs.registerLanguage("cobol", hljsCobol);

/**
 * 拡張子からhighlight.jsの言語名に変換
 * cf: <https://github.com/highlightjs/highlight.js/blob/main/SUPPORTED_LANGUAGES.md>
 */
const extensionToHljsLanguage = (ext: string): string => {
  if (genericExtension.includes(ext)) {
    return "plaintext";
  }
  switch (ext) {
    case "cob":
      return "cobol";
    case "exs":
      return "elixir";
    case "asm":
      return "x86asm";
    case "bas":
      return "basic";
    default:
      return ext;
  }
};

export default Vue.extend({
  name: "CorpReview",
  components: {
    Editor,
    MessageModal,
    VariableInput,
    ReturnTop,
    CommentCodeBlock,
  },
  props: {
    loginData: Object as PropType<UserProfile>,
    logged: Boolean, // ログイン状態
    mq: String,
  },
  data() {
    return {
      defaultIconUrl,
      reviewData: {} as ReviewResponse,
      receiveModal: false,
      dealData: {} as DealResponse,
      isEnlarge: false,
      accordionToggleFlag: true,
      mode: "comment",
      tabs: [
        { mode: "comment", text: "コメント" },
        { mode: "code", text: "コード" },
      ],
      reaction: [
        { id: "smiley", src: "/images/deal/emoji_1.svg" },
        { id: "shy", src: "/images/deal/emoji_2.svg" },
        { id: "hmm", src: "/images/deal/emoji_3.svg" },
        { id: "cry", src: "/images/deal/emoji_4.svg" },
        { id: "applause", src: "/images/deal/emoji_5.svg" },
        { id: "ok", src: "/images/deal/emoji_6.svg" },
      ],
      reactionOpen: {} as { [key: number]: boolean },
      commentInput: "",
      codeLineStatus: {} as { [key: string]: any },
      codeLineIndex: 0,
      codeCommentTriggerStyle: {
        display: "flex",
        top: "0",
      },
      modalOpen: false,
      getUserNickName,
      isCommentEditMode: true,
      inputReviewComment: "",
      uploadZipFile: null as File | null,
      formattedReviewComment: "",
      parsedContent: [] as { type: string | null; content: string | string[] }[],
      // 取引状態
      draft: Draft,
      underReview: UnderReview,
      agreementPending: AgreementPending,
      inReview: InReview,
      completed: Completed,
      // 取引種別
      codeType: Code,
      zipFileType: ZipFile,
      githubUrlType: GithubUrl,
      // 査定状態
      assessmentStatus: Assessment,
      approvalStatus: Approval,
      rejectionStatus: Rejection,
      move: false,
    };
  },
  async beforeRouteEnter(to, from, next) {
    try {
      store.dispatch("updateAuth");
      // レビュー取得
      const res = await getReview(to.params.dealId);
      next((vm) => {
        vm.$data.reviewData = res;
      });
    } catch (e) {
      next(vm => {
        vm.$emit('errorToast', 'この依頼の閲覧権限がありません。');
        vm.$router.push({ name: "Top" });
      })
    }
  },
  mounted() {
    // メールから依頼を開くときはログインデータの反映がされていないことがあるため、再度アクセス可能なユーザかチェック
    let param = location.search;
    // if (param.includes("fromMail")) {
    //   this.accessDetail();
    // }
  },
  computed: {
    /*************
     * 依頼詳細関連
     *************/
    getLoginData(): UserProfile {
      return this.loginData ? this.loginData : this.$store.getters.userProfile;
    },
    getCorporationIcon(): string {
      return this.$store.getters.userProfile.corporationsData.iconUrl;
    },
    formattedPurchaseOverview(): string {
      const urlRegex: RegExp = /(https?:\/\/[^\s]+)/g;
      return this.reviewData.purchaseOverview
        ? this.reviewData.purchaseOverview.replace(urlRegex, (url: string) => {
            return `<a href="${url}" target="_blank">${url}</a>`;
          })
        : "";
    },
    formattedCodeEditor(): {} {
      const urlRegex: RegExp = /(https?:\/\/[^\s]+)/g;
      return this.reviewData.codeEditor
        ? this.reviewData.codeEditor.map((item) => {
            return {
              ...item,
              remarks: item.remarks.replace(urlRegex, (url: string) => {
                return `<a href="${url}" target="_blank">${url}</a>`;
              }),
            };
          })
        : {};
    },
    /**  ステータスに応じた文言を返却 */
    statusLabel(): string {
      switch (this.reviewData.dealStatus) {
        case Draft:
          return "下書き";
        case UnderReview:
          return "査定中";
        case AgreementPending:
          return "承諾待ち";
        case InReview:
          return "レビュー中";
        case Completed:
          return "完了";
        default:
          return "";
      }
    },
    /** 編集できるユーザーかどうか */
    isEdit(): boolean {
      const user =  this.$store.getters.userProfile;
      if (this.reviewData.purchaseUserId == user.userId) {
        return true;
      } else {
        return false;
      }
    },
    /*************
     * レビュー関連
     *************/
    reviewCommentRegisterBtnDisabled() {
      if (this.inputReviewComment == null || this.inputReviewComment.trim() == "") {
        return true;
      }
      return false;
    },
    countComment(): number {
      if (Object.keys(this.reviewData).length) {
        return this.reviewData.reviewComment.length;
      } else {
        // async/awaitを待たずに実行するため、undefindが返ってくる対策
        return 0;
      }
    },
    countCodeComment(): number {
      if (Object.keys(this.reviewData).length) {
        return this.reviewData.reviewComment.filter((v) => v.codeBlock.fileName && v.codeBlock.fileName != "").length;
      } else {
        // async/awaitを待たずに実行するため、undefindが返ってくる対策
        return 0;
      }
    },
    targetCodeAbstract: function () {
      var codeEditor = this.reviewData.codeEditor;
      return function (target: CodeBlock) {
        var codeText = codeEditor.filter((v) => v.fileName + v.extension == target.fileName)[0].text;
        var codeTextLength = codeText.length;
        var firstIndex;
        var lastIndex;
        if (codeTextLength <= 3) {
          firstIndex = 0;
          lastIndex = codeTextLength;
        } else {
          if (target.line < 2) {
            firstIndex = 0;
            lastIndex = 3;
          } else if (codeTextLength - 1 < target.line) {
            firstIndex = codeTextLength - 3;
            lastIndex = codeTextLength;
          } else {
            firstIndex = target.line - 2;
            lastIndex = target.line + 1;
          }
        }
        return codeText.slice(firstIndex, lastIndex);
      };
    },
  },
  methods: {
    toEdit() {
      this.move = true;
      this.$router.push({ name: "CorpReviewEdit", params: { dealId: this.reviewData.dealId } });
    },
    toProject() {
      this.move = true;
      this.$router.push({
        name: "CorpProjectDetail",
        params: { corporateId: this.getLoginData.corporationsData.corporateId, projectId: this.reviewData.projectId },
      });
    },
    accordionToggle() {
      if (!this.move) {
        this.accordionToggleFlag = this.accordionToggleFlag == true ? false : true;
      }
    },
    initSet() {
      this.setIconDefalt();
      this.setCodeEditorComment();
    },
    /** アイコン画像がない場合、デフォルト画像切り替え */
    setIconDefalt() {
      if (!this.reviewData.purchaseUserIconUrl) {
        this.reviewData.purchaseUserIconUrl = defaultIconUrl;
      }
    },
    /** 経過時間の割り出し */
    getUpdated(createDate?: string): string | null {
      if (!createDate) {
        return null;
      }
      let posted = new Date(createDate);
      // 差分 = 現在の日時 - 投稿日時
      let diff = new Date().getTime() - posted.getTime();
      // 経過時間をDateに変換
      let progress = new Date(diff);
      let text = "";

      if (progress.getUTCFullYear() - 1970) {
        text = progress.getUTCFullYear() - 1970 + "年前";
      } else if (progress.getUTCMonth()) {
        text = progress.getUTCMonth() + "ヶ月前";
      } else if (progress.getUTCDate() - 1) {
        text = progress.getUTCDate() - 1 + "日前";
      } else if (progress.getUTCHours()) {
        text = progress.getUTCHours() + "時間前";
      } else if (progress.getUTCMinutes()) {
        text = progress.getUTCMinutes() + "分前";
      } else {
        text = "たった今";
      }
      return text;
    },
    /** 日付のみに変換 */
    convertToDataOnly(createDate?: string) {
      if (!createDate) {
        return "-";
      }
      return new Date(createDate).toLocaleDateString();
    },
    /** アップロード時のファイル名を抽出 */
    extractionFileName(url: string): string | null {
      const regex = /\/([^/]+\.zip)_/;
      const match = url.match(regex);
      if (match) {
        return match[1];
      } else {
        return null;
      }
    },
    /** カンマ入り金額に変換 */
    dispLocaleString(amount: number): string {
      return amount?.toLocaleString();
    },
    /** レビューコメントを基にコードエディターのコメント設置 */
    setCodeEditorComment() {
      let codeEditor = this.reviewData.codeEditor;
      let reviewComment = this.reviewData.reviewComment;
      for (var i = 0; i < reviewComment.length; i++) {
        if (reviewComment[i].codeBlock.fileName) {
          for (var j = 0; j < codeEditor.length; j++) {
            if (codeEditor[j].fileName + codeEditor[j].extension == reviewComment[i].codeBlock.fileName) {
              var index = reviewComment[i].codeBlock.line - 1;
              var text = reviewComment[i].text;
              var time = reviewComment[i].postTime;
              this.$set(this.codeLineStatus, "commentFix-" + j + "-" + index, true);
              this.$set(this.codeLineStatus, "commentInput-" + j + "-" + index, text);
              this.$set(this.codeLineStatus, "commentTime-" + j + "-" + index, time);
              break;
            }
          }
        }
      }
    },
    /** コメントに表示するユーザーアイコンの取得 */
    getCommentCorporationIcon(userId: string, corporationIconUrl: string): string {
      if (userId.length > 20) {
        return "/images/deal/idh_icon.jpg";
      }
      if (!corporationIconUrl) {
        return defaultIconUrl;
      }
      return corporationIconUrl;
    },
    /** 法人アイコンの取得 */
    getCorporationIcon(): string {
      return this.getLoginData.corporationsData.iconUrl ?? defaultIconUrl
    },
    /** コメントに表示するユーザー名の取得 */
    getCommentUserName(userId: string, userNickName: string): string {
      if (userId.length > 20) {
        return "IDHエンジニア";
      }
      return getUserNickName(userId, userNickName);
    },
    changeMode(key: string) {
      this.mode = key;
    },
    reactionOver(key: number) {
      if (this.mq != "sp") {
        this.$set(this.reactionOpen, key, true);
      }
    },
    reactionLeave(key: number) {
      if (this.mq != "sp") {
        this.$set(this.reactionOpen, key, false);
      }
    },
    reactionToggle(key: number) {
      this.$set(this.reactionOpen, key, !this.reactionOpen[key]);
    },
    reacionOff(key: number) {
      this.$set(this.reactionOpen, key, false);
    },
    codeLineOver(key: number, index: number, event: Event) {
      if (!this.codeLineStatus["commentFix-" + key + "-" + index]) {
        this.$set(this.codeLineStatus, "line-" + key + "-" + index, true);
        this.$set(this.codeLineStatus, "commentTrigger-" + key + "-" + index, true);
        this.codeLineIndex = index;
        let targetElement = event.target as HTMLElement;
        let targetTop = targetElement.getBoundingClientRect().top;
        let parentElement = targetElement.closest(".editorwrap-ex") as HTMLElement;
        let parentTop = parentElement.getBoundingClientRect().top;
        this.codeCommentTriggerStyle.top = targetTop - parentTop - 1 + "px";
      }
    },
    codeLineLeave(key: number, index: number) {
      this.$set(this.codeLineStatus, "line-" + key + "-" + index, false);
      this.$set(this.codeLineStatus, "commentTrigger-" + key + "-" + index, false);
    },
    codeCommentTriggerOver(key: number, index: number) {
      this.$set(this.codeLineStatus, "line-" + key + "-" + index, true);
      this.$set(this.codeLineStatus, "commentTrigger-" + key + "-" + index, true);
    },
    codeCommentTriggerLeave(key: number, index: number) {
      this.codeLineLeave(key, index);
    },
    codeCommentShowToggle(key: number, index: number) {
      this.$set(
        this.codeLineStatus,
        "comment-" + key + "-" + index,
        !this.codeLineStatus["comment-" + key + "-" + index]
      );
      if (!this.codeLineStatus["comment-" + key + "-" + index]) {
        this.$set(this.codeLineStatus, "commentInput-" + key + "-" + index, "");
      }
    },
    codeCommentShowHidden(key: number, index: number) {
      this.$set(this.codeLineStatus, "comment-" + key + "-" + index, false);
      this.$set(this.codeLineStatus, "commentInput-" + key + "-" + index, "");
    },
    /** コードコメントの登録 */
    async codeCommentSubmit(key: number, index: number) {
      if (this.codeLineStatus["commentInput-" + key + "-" + index]) {
        let reviewComment: ReviewComment = {
          userId: this.getLoginData.userId,
          codeBlock: {
            fileName: this.reviewData.codeEditor[key].fileName + this.reviewData.codeEditor[key].extension,
            line: index + 1,
          },
          text: this.codeLineStatus["commentInput-" + key + "-" + index],
          postTime: new Date(),
          reactionMark: [0, 0, 0, 0, 0, 0],
        };
        let reviewComments = this.reviewData.reviewComment.concat();
        reviewComments.push(reviewComment);

        var req: UpdateCorporateReviewStatusRequest = {
          dealStatus: this.reviewData.dealStatus,
          reviewComment: reviewComments,
        };
        try {
          var res = await updateReviewStatus(this.reviewData.dealId, req);
          this.reviewData = res;
          // this.initSet();
          this.$set(this.codeLineStatus, "comment-" + key + "-" + index, false);
          this.$emit("toast", "コメントを登録しました");
        } catch (e) {
          console.log(e);
          if (axios.isAxiosError(e) && e.response) {
            var resError = e.response.data as ErrorResponse;
            if (resError.message == null) {
              this.$emit("errorToast", "コメント登録に失敗しました。しばらく経ってからやり直してください。");
            } else {
              this.$emit("errorToast", resError.message);
            }
          }
        }
        
      }
    },
    modalClose() {
      this.modalOpen = false;
    },
    lineHtmls(code: string, ext: string) {
      const { value } = hljs.highlight(code, {
        language: extensionToHljsLanguage(ext.slice(1)),
      });
      return value;
    },
    getExtension(fileName: string) {
      var ext = "";
      Array.prototype.forEach.call(this.reviewData.codeEditor, (item) => {
        var name = item.fileName + item.extension;
        if (ext === "" && name === fileName) {
          ext = item.extension;
        }
      });
      return ext;
    },
    /** クリックによるファイル登録検知 */
    handleFileChange(event: Event) {
      const target = event.target as HTMLInputElement;
      const files = target.files;
      if (files && files.length > 0) {
        this.uploadFile(files[0]);
      }
      target.value = "";
    },
    /** 添付ファイル格納 */
    uploadFile(file: File | undefined) {
      if (!file) return;
      if (this.hasErrFile(file)) {
        return;
      }
      this.uploadZipFile = file;
    },
    /** ファイルが有効なものかチェック */
    hasErrFile(file: File): boolean {
      const validExtensions = /^(\.zip|\.rar|\.7z)$/i;
      const fileExtension = file.name.split(".").pop()?.toLowerCase();
      if (!validExtensions.test("." + fileExtension)) {
        this.$emit("errorToast", "無効なファイル形式です。許可されている形式は .zip / .7z / .rar です。");
        return true;
      }
      const maxFileSizeInBytes = 10 * 1024 * 1024; // 10MB
      if (file.size > maxFileSizeInBytes) {
        this.$emit("errorToast", "ファイルサイズが大きすぎます。10MB以下のZIPファイルを選択してください。");
        return true;
      }

      return false;
    },
    /** レビューコメントフォームにZipファイル追加 */
    addZipFile(e: Event) {
      e.preventDefault();
      if (!(e?.target instanceof HTMLInputElement)) {
        return;
      }
      const file = e.target.files?.[0];
      if (!file) {
        return;
      }
      this.uploadZipFile = file;
    },
    clickAddFileButon() {
      (this.$refs.fileUploader as HTMLInputElement).click();
    },
    /** レビューコメントフォームのZipファイル削除 */
    deleteFile() {
      this.uploadZipFile = null;
    },
    /** レビューコメントフォームにコード追加 */
    addCode() {
      this.inputReviewComment += "{code}ここにコード入力{end-code}";
    },
    /** レビューコメントフォームにコードブロックの追加 */
    addCodeBlock() {
      this.inputReviewComment += "\n{code-block}\nここにコード入力\n{end-code-block}\n";
    },
    /** レビューコメント"プレビュー"内のコード（inline-code）・コードブロックを変換 */
    parseCommentPreview(comment: string) {
      const regex = /\{code-block\}([\s\S]*?)\{end-code-block\}/g;
      const convertedInlineCode = this.convertInlineCodeToHtml(comment);
      const matches = convertedInlineCode.split(regex);
      this.parsedContent = this.separateByCodeBlockAndText(matches);
    },
    /** レビューコメント内のコード（inline-code）・コードブロックを変換 */
    parseComment(comment: string): { type: string | null; content: string | string[] }[] {
      const regex = /\{code-block\}([\s\S]*?)\{end-code-block\}/g;
      const convertedInlineCode = this.convertInlineCodeToHtml(comment);
      const matches = convertedInlineCode.split(regex);

      return this.separateByCodeBlockAndText(matches);
    },
    /** コードブロックとテキストを分類 */
    separateByCodeBlockAndText(splitComments: string[]): { type: string | null; content: string | string[] }[] {
      return splitComments.map((comment, index) => {
        if (index % 2 == 1) {
          // コードを一行ごとに分割
          const codeArray = comment.split(/\n/);
          codeArray.shift();
          codeArray.pop();
          return { type: "CommentCodeBlock", content: codeArray };
        } else {
          return { type: null, content: comment };
        }
      });
    },
    /** 独自コードタグをHTMLに変換 */
    convertInlineCodeToHtml(comment: string): string {
      return comment.replaceAll("{code}", '<span class="comment-code-inline">').replaceAll("{end-code}", "</span>");
    },
    /** コメント入力 / プレビューの切り替え */
    toggleInputCommentMode() {
      this.isCommentEditMode = !this.isCommentEditMode;
      if (!this.isCommentEditMode) {
        this.parseCommentPreview(this.inputReviewComment);
      }
    },
    /** レビューコメントの登録 */
    async reviewCommentSubmit(props: { assessmentStatus?: string; dealStatus?: string }) {
      const { assessmentStatus, dealStatus } = props;
      const maxfileNameLength = 50;
      if (this.uploadZipFile && this.uploadZipFile.name.length > maxfileNameLength) {
        this.$emit("errorToast", "ZIPファイル名は、拡張子を含め'50文字以内'にしてください。");
        return;
      }
      if (!this.inputReviewComment && dealStatus != Completed) {
        this.$emit("errorToast", "コメントを入力してください。");
        return;
      }
      let newReviewComment: ReviewCommentRequest = {
        userId: this.getLoginData.userId,
        codeBlock: {
          fileName: "",
          line: 0,
        },
        text: this.inputReviewComment,
        postTime: new Date(),
        assessmentStatus: assessmentStatus,
        reactionMark: [0, 0, 0, 0, 0, 0],
      };
      const reviewComments = this.reviewData.reviewComment.concat();
      reviewComments.push(newReviewComment);

      const req: UpdateCorporateReviewStatusRequest = {
        dealStatus: dealStatus ?? this.reviewData.dealStatus,
        reviewComment: reviewComments,
      };

      try {
        let res = await updateReviewStatus(this.reviewData.dealId, req);
        // Zipファイルが添付されていれば登録
        if (this.uploadZipFile != null) {
          const registerZipFileReq: RegisterCorporateReviewCommentZipFile = {
            dealId: this.reviewData.dealId,
            isComment: true,
            zipFile: this.uploadZipFile!,
          };
          res = await registerZipFile(registerZipFileReq);
        }
        this.reviewData = res;
        this.initCommentForm();
        if (dealStatus == Completed) {
          this.$emit("toast", "レビューを終了しました。");
          return
        }
        this.$emit("toast", "コメントを登録しました");
      } catch (e) {
        console.log(e);
        if (axios.isAxiosError(e) && e.response) {
          var resError = e.response.data as ErrorResponse;
          if (resError.message == null) {
            this.$emit("errorToast", "コメント登録に失敗しました。しばらく経ってからやり直してください。");
          } else {
            this.$emit("errorToast", resError.message);
          }
        }
      }
    },
    /** レビューコメントフォームの初期化 */
    initCommentForm() {
      this.inputReviewComment = "";
      if (this.isCommentEditMode == false) this.toggleInputCommentMode();
      if (this.$refs.fileUploader instanceof HTMLInputElement) {
        this.$refs.fileUploader.value = "";
      }
      this.deleteFile();
    },
  },
  filters: {
    amountLocaleString: function (amount: number) {
      if (amount) {
        return amount.toLocaleString();
      } else {
        // async/awaitを待たずに実行するため、undefindが返ってくる対策
        return amount;
      }
    },
    fileNameOthersHide: function (fileName: string) {
      return fileName.replace(/その他$/, "");
    },
    timeDiff: function (date: Date) {
      moment.locale("ja");
      return moment(date).fromNow();
    },
  },
});
